var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/return-await */
import { acceptContactAsync, addContactAsync, removeContactAsync } from 'membre/store/actions';
import { MembreRelation } from './MembreRelation.class';
import { dispatch } from 'store/store';
/**
 * Chaque objet est un lien unissant deux membres
 */
export class MembreContact extends MembreRelation {
    /**
     * Constructeur de l'objet MembreContact
     * @param contact contient les données de l'objet
     */
    constructor(contact) {
        if (contact) {
            const { idMembreContact, idExpediteur, idRecepteur, dateDemande, dateDebutContact, status } = contact;
            super({
                idRelation: idMembreContact,
                idExpediteur,
                idRecepteur,
            });
            this.dateDemande = dateDemande;
            this.dateDebutContact = dateDebutContact;
            this.status = status;
        }
    }
    /**
     * Ajoute un membre en contact
     * @param idMembre Identifiant du membre à ajouter
     */
    static add(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield dispatch(addContactAsync(idMembre)).then((res) => res.payload);
        });
    }
    /**
     * Accepte la demande de contact
     */
    accept() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield dispatch(acceptContactAsync(this.idExpediteur)).then((res) => res.payload);
        });
    }
    /**
     * Supprime la demande de contact ou le contact
     * @param idMembre Identifiant du membre à supprimer
     */
    static remove(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield dispatch(removeContactAsync(idMembre)).then((res) => res.payload);
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlQ29udGFjdC5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk1lbWJyZUNvbnRhY3QuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsb0RBQW9EO0FBQ3BELE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxlQUFlLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUMvRixPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sd0JBQXdCLENBQUM7QUFDeEQsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGFBQWEsQ0FBQztBQUV2Qzs7R0FFRztBQUNILE1BQU0sT0FBTyxhQUFjLFNBQVEsY0FBYztJQStCaEQ7OztPQUdHO0lBQ0gsWUFBbUIsT0FBZ0M7UUFDbEQsSUFBSSxPQUFPLEVBQUU7WUFDWixNQUFNLEVBQUUsZUFBZSxFQUFFLFlBQVksRUFBRSxXQUFXLEVBQUUsV0FBVyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sRUFBRSxHQUFHLE9BQU8sQ0FBQztZQUV0RyxLQUFLLENBQUM7Z0JBQ0wsVUFBVSxFQUFFLGVBQWU7Z0JBQzNCLFlBQVk7Z0JBQ1osV0FBVzthQUNYLENBQUMsQ0FBQztZQUVILElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDO1lBQy9CLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxnQkFBZ0IsQ0FBQztZQUN6QyxJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztTQUNyQjtJQUNGLENBQUM7SUFFRDs7O09BR0c7SUFDSSxNQUFNLENBQU8sR0FBRyxDQUFDLFFBQWdCOztZQUN2QyxPQUFPLE1BQU0sUUFBUSxDQUFDLGVBQWUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLEdBQUcsRUFBRSxFQUFFLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQzdFLENBQUM7S0FBQTtJQUVEOztPQUVHO0lBQ1UsTUFBTTs7WUFDbEIsT0FBTyxNQUFNLFFBQVEsQ0FBQyxrQkFBa0IsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUN6RixDQUFDO0tBQUE7SUFFRDs7O09BR0c7SUFDSSxNQUFNLENBQU8sTUFBTSxDQUFDLFFBQWdCOztZQUMxQyxPQUFPLE1BQU0sUUFBUSxDQUFDLGtCQUFrQixDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsR0FBRyxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDaEYsQ0FBQztLQUFBO0NBQ0QifQ==